const firebaseConfig = {

    apiKey: "AIzaSyA6y4EOBU_-9M1DaG1_IQz1vKYw5zbBFNY",
    authDomain: "medico-health-6bf75.firebaseapp.com",
    projectId: "medico-health-6bf75",
    storageBucket: "medico-health-6bf75.appspot.com",
    messagingSenderId: "293182482307",
    appId: "1:293182482307:web:b1da88724552dbd30278b6"
};

export default firebaseConfig;